export const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'it'];
export const FINAL_STEP = 3;
